/* eslint-disable */

!((document, Drupal, $, UIkit) => {
  'use strict';

  /**
   * UIkit custom lightbox
   */
  Drupal.behaviors.UIkitCustomLightbox = {

    attach: function () {

      function getIframe(src, width, height, autoplay) {
        return `<iframe src="${src}" width="${width}" height="${height}" style="max-width: 100%; box-sizing: border-box;" frameborder="0" allowfullscreen allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" uk-video="autoplay: ${autoplay}" uk-responsive></iframe>`;
      }

      UIkit.component('lightboxPanel', UIkit.component('lightboxPanel').extend({
        events: [
          {
            name: 'itemload',

            handler(_, item) {

              const {source, type, alt} = item;

              this.setItem(item, '<span uk-spinner></span>');

              if (!source) {
                return;
              }

              let matches;

              // Image
              if (type === 'image' || source.match(/\.(jp(e)?g|png|gif|svg|webp)($|\?)/i)) {

                getImage(source).then(
                  img => this.setItem(item, `<img width="${img.width}" height="${img.height}" src="${source}" alt="${alt ? alt : ''}">`),
                  () => this.setError(item)
                );

                // Video
              } else if (type === 'video' || source.match(/\.(mp4|webm|ogv)($|\?)/i)) {

                const video = $(`<video controls playsinline${item.poster ? ` poster="${item.poster}"` : ''} uk-video="${this.videoAutoplay}"></video>`);
                attr(video, 'src', source);

                once(video, 'error loadedmetadata', type => {
                  if (type === 'error') {
                    this.setError(item);
                  } else {
                    attr(video, {width: video.videoWidth, height: video.videoHeight});
                    this.setItem(item, video);
                  }
                });

                // Iframe
              } else if (type === 'iframe' || source.match(/\.(html|php)($|\?)/i)) {

                this.setItem(item, `<iframe class="uk-lightbox-iframe" src="${source}" frameborder="0" allowfullscreen></iframe>`);

                // YouTube
              } else if ((matches = source.match(/\/\/.*?youtube(-nocookie)?\.[a-z]+\/watch\?v=([^&\s]+)/) || source.match(/()youtu\.be\/(.*)/) || source.match(/()youtube\.com\/embed\/(.*)/))) {

                const [, , id] = matches;
                const width = 1000;
                const height = 562.5;

                this.setItem(item, getIframe(`https://www.youtube${matches[1] || ''}.com/embed/${id}`, width, height, this.videoAutoplay));

                // Vimeo
              } else if ((matches = source.match(/(\/\/.*?)vimeo\.[a-z]+\/([0-9]+).*?/))) {

                ajax(`https://vimeo.com/api/oembed.json?maxwidth=1920&url=${encodeURI(source)}`, {responseType: 'json', withCredentials: false})
                  .then(
                    ({response: {height, width}}) => this.setItem(item, getIframe(`https://player.vimeo.com/video/${matches[2]}`, width, height, this.videoAutoplay)),
                    () => this.setError(item)
                  );

              }
            }
          }
        ]
      }));
    }

  };

})(document, Drupal, jQuery, UIkit);
